<template lang="pug">
div
	v-item-group(v-model="stepper.bookingType" v-if="!bookingStore.isPostSale")
		div.tw-flex.tw-flex-row.tw-justify-start
			v-item(v-for="(item, i) of bookingTypes" :key="i" :value="item.value")
				div.tw-flex.tw-items-center.tw-gap-2.tw-py-5(
					class=" emd:tw-py-2"
					:class="{'buy-type-base-item': true, 'active': stepper.bookingType == item.value}"
					@click="changeBookingType(item)"
				)
					img(v-if="item.activeIcon && stepper.bookingType == item.value" :src="item.activeIcon")
					img(v-if="item.icon && stepper.bookingType != item.value" :src="item.icon")
					span.tw-font-bold(class="tw-leading-[18px]") {{item.label}}
	div.tw-card.tw-bg-white.search-box(class="tw-px-[20px] emd:tw-px-3 tw-pt-[30px]")
		tickets-form(v-if="stepper.bookingType == 'tickets'" :out-of-card="outOfCard")
		carnet-form(v-else-if="stepper.bookingType == 'carnet'" :out-of-card="outOfCard")

	div.tw-mt-10(ref="outOfCard")
</template>

<script setup>
import {computed, onMounted, ref} from 'vue';
import { useBookingStore } from '@/stores/booking';
import { useBookingStepperStore } from '@/stores/booking-stepper';
import TicketsForm from "@/sale/components/tab1_search/tickets-form.vue";
import CarnetForm from "@/sale/components/tab1_search/carnet-form.vue";
import {useI18n} from "vue-i18n";

const outOfCard = ref();
const i18n = useI18n();
const bookingTypes = [
	{
		label: i18n.t('sale.search.tickets', 'BIGLIETTI'),
		value: 'tickets',
		icon: new URL("/layout/ticket.svg", import.meta.url),
		activeIcon: new URL("/layout/ticket_active.svg", import.meta.url)
	},
	/*{
		label: 'ABBONAMENTI',
		value: 'subscriptions',
		isSelected: false
	},*/
	{
		label: i18n.t('sale.search.carnet', 'CARNET'),
		value: 'carnet',
		icon: new URL("/layout/tickets.svg", import.meta.url),
		activeIcon: new URL("/layout/tickets_active.svg", import.meta.url)
	},
	/*{
		label: 'PROMOZIONI E SERVIZI REGIONALI',
		value: 'promo',
		isSelected: false
	},
	{
		label: 'CARTE REGALO',
		value: 'gift_cards',
		isSelected: false
	},
	{
		label: 'FRECCIA CLUB',
		value: 'freccia_club',
		isSelected: false
	},
	{
		label: 'TRENITALIA PASS',
		value: 'pass',
		isSelected: false
	}*/
];
const stepper = useBookingStepperStore();
const bookingStore = useBookingStore();
const color = 'red';

function changeBookingType(bookingType) {
	stepper.switchBetweenTicketOrCarnet(bookingType.value);

	if ('tickets' == stepper.bookingType) {
		bookingStore.setStartDate(new Date());
	} else if ('carnet' == stepper.bookingType) {
		const d = new Date();
		d.setHours(0, 0, 0, 0);
		bookingStore.setStartDate(d);
	}
}


onMounted(() => {
	if(!bookingStore.searchFilters.startDate) {
		let tmp = new Date();
		if (tmp.getMinutes() < 30) {
			tmp.setMinutes(30);
		} else {
			tmp.setHours((tmp.getHours() + 1));
			tmp.setMinutes(0);
		}

		bookingStore.setStartDate(tmp);
	}
});
</script>

<style scoped>

.search-box{
	border-top-left-radius: 0;
}
.buy-type-base-item{
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	text-align: center;
	width: 180px;
	font-size: 16px;
	background-color: #fafafa;
	color: #bcbcbc;
	border-top-right-radius: 24px;
	border-top-left-radius: 24px;
}

.buy-type-base-item.active{
	background-color: white;
	color: var(--color-primary-dark);
}
.buy-type-base-item img{
	height: 26px;
	width: 26px;
}
</style>